// React
import { PropsWithChildren, createContext } from "react"

// Types
import type { ProductType, TaxCodeList } from "types"

// Utils
import { useProduct, useTaxCode } from "utils"

export const DropdownContext = createContext<{
  product: ProductType[]
  tax: TaxCodeList[]
}>({
  product: [],
  tax: []
})

export function DropdownProvider(params: PropsWithChildren<{}>): JSX.Element {
  // Hooks
  const product = useProduct()
  const tax = useTaxCode()

  return (
    <DropdownContext.Provider value={{
      product: product.data,
      tax: tax.data
    }}>
      {params.children}
    </DropdownContext.Provider>
  )
}